function snippetForEnv(scriptUrl) {
    if (!scriptUrl) {
        return null;
    }
    return scriptUrl;
}

export default function getScriptSnippet() {
    let scriptUrl;
    if (typeof window !== 'undefined' && window.APP_CONFIG) {
        scriptUrl = window.APP_CONFIG;
    } else {
        scriptUrl = process.env;
    }
    return snippetForEnv(scriptUrl);
}